/* @ngInject */
const myDispositionForm = (
  wagonFields
) => {
  return {
    restrict: 'E',
    scope: {
      myDisposition: '=',
      enableValidator: '=?',
    },
    template: require('./myDispositionForm.html'),
    /* @ngInject */
    controller: ($scope) => {
      $scope.fieldsOptions = wagonFields
    },
    link: {
      pre: (scope, element, attrs) => {  },
      post: (scope, element, attrs, ctrl) => { },
    },
  }
}
export default myDispositionForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/directives/forms/myDispositionForm.js